export function formatCottageCalendarUpdate(value: number) {
  if (value === 0) {
    return 'Calendario actualizado hoy.'
  }
  if (value === 1) {
    return 'Calendario actualizado ayer.'
  }
  if (value >= 14) {
    return 'Calendario actualizado hace más de 2 semanas.'
  }
  return `Calendario actualizado hace ${value} días.`
}
